export class LoggingConstants {

    public static readonly empty = '';
    // NOTE: to modify the views/actions, a new event has to be registered for Asimov and added to the gateway code here:
    // https://microsoft.visualstudio.com/SME/_git/gateway?path=%2Fsrc%2FMicrosoft.ManagementExperience.FrontEnd%2FControllers%2FDiagnosticAndTelemetryController.cs
    // Modifying either of these lists can cause breaks in the telemetry pipeline.
    public static readonly views = {
        smeUIControl: 'sme-ui-control'
    };

    public static readonly actions = {
        click: 'command-click'
    };

    public static readonly dataFields = {
        controlType: 'controlType',
        controlName: 'controlName',
        controlId: 'controlId',
        eventLocation: 'eventLocation',
        eventLabel: 'eventLabel',
        result: 'result',
        nodeId: 'nodeId'
    };
}
